module.exports = /*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */
    (function() {
        "use strict";

        function peg$subclass(child, parent) {
            function ctor() { this.constructor = child; }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
        }

        function peg$SyntaxError(message, expected, found, location) {
            this.message  = message;
            this.expected = expected;
            this.found    = found;
            this.location = location;
            this.name     = "SyntaxError";

            if (typeof Error.captureStackTrace === "function") {
                Error.captureStackTrace(this, peg$SyntaxError);
            }
        }

        peg$subclass(peg$SyntaxError, Error);

        peg$SyntaxError.buildMessage = function(expected, found) {
            var DESCRIBE_EXPECTATION_FNS = {
                literal: function(expectation) {
                    return "\"" + literalEscape(expectation.text) + "\"";
                },

                "class": function(expectation) {
                    var escapedParts = "",
                        i;

                    for (i = 0; i < expectation.parts.length; i++) {
                        escapedParts += expectation.parts[i] instanceof Array
                            ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1])
                            : classEscape(expectation.parts[i]);
                    }

                    return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
                },

                any: function(expectation) {
                    return "any character";
                },

                end: function(expectation) {
                    return "end of input";
                },

                other: function(expectation) {
                    return expectation.description;
                }
            };

            function hex(ch) {
                return ch.charCodeAt(0).toString(16).toUpperCase();
            }

            function literalEscape(s) {
                return s
                    .replace(/\\/g, '\\\\')
                    .replace(/"/g,  '\\"')
                    .replace(/\0/g, '\\0')
                    .replace(/\t/g, '\\t')
                    .replace(/\n/g, '\\n')
                    .replace(/\r/g, '\\r')
                    .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
                    .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
            }

            function classEscape(s) {
                return s
                    .replace(/\\/g, '\\\\')
                    .replace(/\]/g, '\\]')
                    .replace(/\^/g, '\\^')
                    .replace(/-/g,  '\\-')
                    .replace(/\0/g, '\\0')
                    .replace(/\t/g, '\\t')
                    .replace(/\n/g, '\\n')
                    .replace(/\r/g, '\\r')
                    .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
                    .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
            }

            function describeExpectation(expectation) {
                return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
            }

            function describeExpected(expected) {
                var descriptions = new Array(expected.length),
                    i, j;

                for (i = 0; i < expected.length; i++) {
                    descriptions[i] = describeExpectation(expected[i]);
                }

                descriptions.sort();

                if (descriptions.length > 0) {
                    for (i = 1, j = 1; i < descriptions.length; i++) {
                        if (descriptions[i - 1] !== descriptions[i]) {
                            descriptions[j] = descriptions[i];
                            j++;
                        }
                    }
                    descriptions.length = j;
                }

                switch (descriptions.length) {
                    case 1:
                        return descriptions[0];

                    case 2:
                        return descriptions[0] + " or " + descriptions[1];

                    default:
                        return descriptions.slice(0, -1).join(", ")
                            + ", or "
                            + descriptions[descriptions.length - 1];
                }
            }

            function describeFound(found) {
                return found ? "\"" + literalEscape(found) + "\"" : "end of input";
            }

            return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
        };

        function peg$parse(input, options) {
            options = options !== void 0 ? options : {};

            var peg$FAILED = {},

                peg$startRuleFunctions = { svg_path: peg$parsesvg_path },
                peg$startRuleFunction  = peg$parsesvg_path,

                peg$c0 = function(d) { return ops; },
                peg$c1 = /^[Mm]/,
                peg$c2 = peg$classExpectation(["M", "m"], false, false),
                peg$c3 = function(ch, args) {
                    var moveCh = ch
                    // If this is the first move cmd then force it to be absolute.
                    if (firstSubPath) {
                        moveCh = 'M';
                        firstSubPath = false;
                    }
                    ops.push({type: 'moveTo', args: makeAbsolute(moveCh, args[0])});
                    for (var i=1; i < args.length; i++) {
                        // The lineTo args are either abs or relative, depending on the
                        // original moveto command.
                        ops.push({type: 'lineTo', args: makeAbsolute(ch, args[i])});
                    }
                },
                peg$c4 = function(one, rest) { return concatSequence(one, rest); },
                peg$c5 = /^[Zz]/,
                peg$c6 = peg$classExpectation(["Z", "z"], false, false),
                peg$c7 = function() { ops.push({type: 'closePath', args: []}); },
                peg$c8 = /^[Ll]/,
                peg$c9 = peg$classExpectation(["L", "l"], false, false),
                peg$c10 = function(ch, args) {
                    for (var i=0; i < args.length; i++) {
                        ops.push({type: 'lineTo', args: makeAbsolute(ch, args[i])});
                    }
                },
                peg$c11 = /^[Hh]/,
                peg$c12 = peg$classExpectation(["H", "h"], false, false),
                peg$c13 = function(ch, args) {
                    for (var i=0; i < args.length; i++) {
                        ops.push({type: 'lineTo', args: makeAbsoluteFromX(ch, args[i])});
                    }
                },
                peg$c14 = /^[Vv]/,
                peg$c15 = peg$classExpectation(["V", "v"], false, false),
                peg$c16 = function(ch, args) {
                    for (var i=0; i < args.length; i++) {
                        ops.push({type: 'lineTo', args: makeAbsoluteFromY(ch, args[i])});
                    }
                },
                peg$c17 = /^[Cc]/,
                peg$c18 = peg$classExpectation(["C", "c"], false, false),
                peg$c19 = function(ch, args) {
                    for (var i=0; i < args.length; i++) {
                        ops.push({type: 'bezierCurveTo', args: makeAbsoluteMultiple(ch, args[i])});
                    }
                },
                peg$c20 = function(cp1, cp2, last) { return cp1.concat(cp2, last); },
                peg$c21 = /^[Ss]/,
                peg$c22 = peg$classExpectation(["S", "s"], false, false),
                peg$c23 = function(ch, args) {
                    for (var i=0; i < args.length; i++) {
                        ops.push({type: 'bezierCurveTo', args: makeReflected().concat(makeAbsoluteMultiple(ch, args[i]))});
                    }
                },
                peg$c24 = function(cp1, last) { return cp1.concat(last); },
                peg$c25 = /^[Qq]/,
                peg$c26 = peg$classExpectation(["Q", "q"], false, false),
                peg$c27 = function(ch, args) {
                    for (var i=0; i < args.length; i++) {
                        ops.push({type: 'quadraticCurveTo', args: makeAbsoluteMultiple(ch, args[i])});
                    }
                },
                peg$c28 = /^[Tt]/,
                peg$c29 = peg$classExpectation(["T", "t"], false, false),
                peg$c30 = function(ch, args) {
                    for (var i=0; i < args.length; i++) {
                        var reflected = makeReflected();
                        ops.push({type: 'quadraticCurveTo', args: reflected.concat(makeAbsoluteMultiple(ch, args[i]))});
                        lastControl = reflected.slice(0);
                    }
                },
                peg$c31 = /^[Aa]/,
                peg$c32 = peg$classExpectation(["A", "a"], false, false),
                peg$c33 = function(ch, args) {
                    for (var i=0; i < args.length; i++) {
                        var x1 = [lastCoord.slice()];
                        var x2 = [makeAbsolute(ch, args[i].slice(-2))];
                        var absArgs = x1.concat(args[i].slice(0, -2), x2);
                        ellipseFromEllipticalArc.apply(this, absArgs);
                    }
                },
                peg$c34 = function(rx, ry, xrot, large, sweep, last) { return [parseFloat(rx), parseFloat(ry), parseFloat(flatten(xrot).join('')), parseInt(large), parseInt(sweep), last[0], last[1]]; },
                peg$c35 = function(x, y) { return [x, y] },
                peg$c36 = function(number) { return parseFloat(flatten(number).join('')) },
                peg$c37 = "0",
                peg$c38 = peg$literalExpectation("0", false),
                peg$c39 = "1",
                peg$c40 = peg$literalExpectation("1", false),
                peg$c41 = ",",
                peg$c42 = peg$literalExpectation(",", false),
                peg$c43 = ".",
                peg$c44 = peg$literalExpectation(".", false),
                peg$c45 = /^[eE]/,
                peg$c46 = peg$classExpectation(["e", "E"], false, false),
                peg$c47 = "+",
                peg$c48 = peg$literalExpectation("+", false),
                peg$c49 = "-",
                peg$c50 = peg$literalExpectation("-", false),
                peg$c51 = /^[0-9]/,
                peg$c52 = peg$classExpectation([["0", "9"]], false, false),
                peg$c53 = function(digits) { return digits.join('') },
                peg$c54 = /^[ \t\n\r]/,
                peg$c55 = peg$classExpectation([" ", "\t", "\n", "\r"], false, false),

                peg$currPos          = 0,
                peg$savedPos         = 0,
                peg$posDetailsCache  = [{ line: 1, column: 1 }],
                peg$maxFailPos       = 0,
                peg$maxFailExpected  = [],
                peg$silentFails      = 0,

                peg$resultsCache = {},

                peg$result;

            if ("startRule" in options) {
                if (!(options.startRule in peg$startRuleFunctions)) {
                    throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
                }

                peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
            }

            function text() {
                return input.substring(peg$savedPos, peg$currPos);
            }

            function location() {
                return peg$computeLocation(peg$savedPos, peg$currPos);
            }

            function expected(description, location) {
                location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

                throw peg$buildStructuredError(
                    [peg$otherExpectation(description)],
                    input.substring(peg$savedPos, peg$currPos),
                    location
                );
            }

            function error(message, location) {
                location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

                throw peg$buildSimpleError(message, location);
            }

            function peg$literalExpectation(text, ignoreCase) {
                return { type: "literal", text: text, ignoreCase: ignoreCase };
            }

            function peg$classExpectation(parts, inverted, ignoreCase) {
                return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
            }

            function peg$anyExpectation() {
                return { type: "any" };
            }

            function peg$endExpectation() {
                return { type: "end" };
            }

            function peg$otherExpectation(description) {
                return { type: "other", description: description };
            }

            function peg$computePosDetails(pos) {
                var details = peg$posDetailsCache[pos], p;

                if (details) {
                    return details;
                } else {
                    p = pos - 1;
                    while (!peg$posDetailsCache[p]) {
                        p--;
                    }

                    details = peg$posDetailsCache[p];
                    details = {
                        line:   details.line,
                        column: details.column
                    };

                    while (p < pos) {
                        if (input.charCodeAt(p) === 10) {
                            details.line++;
                            details.column = 1;
                        } else {
                            details.column++;
                        }

                        p++;
                    }

                    peg$posDetailsCache[pos] = details;
                    return details;
                }
            }

            function peg$computeLocation(startPos, endPos) {
                var startPosDetails = peg$computePosDetails(startPos),
                    endPosDetails   = peg$computePosDetails(endPos);

                return {
                    start: {
                        offset: startPos,
                        line:   startPosDetails.line,
                        column: startPosDetails.column
                    },
                    end: {
                        offset: endPos,
                        line:   endPosDetails.line,
                        column: endPosDetails.column
                    }
                };
            }

            function peg$fail(expected) {
                if (peg$currPos < peg$maxFailPos) { return; }

                if (peg$currPos > peg$maxFailPos) {
                    peg$maxFailPos = peg$currPos;
                    peg$maxFailExpected = [];
                }

                peg$maxFailExpected.push(expected);
            }

            function peg$buildSimpleError(message, location) {
                return new peg$SyntaxError(message, null, null, location);
            }

            function peg$buildStructuredError(expected, found, location) {
                return new peg$SyntaxError(
                    peg$SyntaxError.buildMessage(expected, found),
                    expected,
                    found,
                    location
                );
            }

            function peg$parsesvg_path() {
                var s0, s1, s2, s3, s4;

                var key    = peg$currPos * 40 + 0,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parsewsp();
                while (s2 !== peg$FAILED) {
                    s1.push(s2);
                    s2 = peg$parsewsp();
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsemoveTo_drawTo_commandGroups();
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = [];
                        s4 = peg$parsewsp();
                        while (s4 !== peg$FAILED) {
                            s3.push(s4);
                            s4 = peg$parsewsp();
                        }
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c0(s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsemoveTo_drawTo_commandGroups() {
                var s0, s1, s2, s3, s4;

                var key    = peg$currPos * 40 + 1,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsemoveTo_drawTo_commandGroup();
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = [];
                    s4 = peg$parsewsp();
                    while (s4 !== peg$FAILED) {
                        s3.push(s4);
                        s4 = peg$parsewsp();
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parsemoveTo_drawTo_commandGroups();
                        if (s4 !== peg$FAILED) {
                            s3 = [s3, s4];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        s1 = [s1, s2];
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsemoveTo_drawTo_commandGroup() {
                var s0, s1, s2, s3, s4;

                var key    = peg$currPos * 40 + 2,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsemoveto();
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = [];
                    s4 = peg$parsewsp();
                    while (s4 !== peg$FAILED) {
                        s3.push(s4);
                        s4 = peg$parsewsp();
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parsedrawto_commands();
                        if (s4 !== peg$FAILED) {
                            s3 = [s3, s4];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        s1 = [s1, s2];
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsedrawto_commands() {
                var s0, s1, s2, s3, s4;

                var key    = peg$currPos * 40 + 3,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsedrawto_command();
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = [];
                    s4 = peg$parsewsp();
                    while (s4 !== peg$FAILED) {
                        s3.push(s4);
                        s4 = peg$parsewsp();
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parsedrawto_commands();
                        if (s4 !== peg$FAILED) {
                            s3 = [s3, s4];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        s1 = [s1, s2];
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsedrawto_command() {
                var s0;

                var key    = peg$currPos * 40 + 4,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$parseclosepath();
                if (s0 === peg$FAILED) {
                    s0 = peg$parselineto();
                    if (s0 === peg$FAILED) {
                        s0 = peg$parsehorizontal_lineto();
                        if (s0 === peg$FAILED) {
                            s0 = peg$parsevertical_lineto();
                            if (s0 === peg$FAILED) {
                                s0 = peg$parsecurveto();
                                if (s0 === peg$FAILED) {
                                    s0 = peg$parsesmooth_curveto();
                                    if (s0 === peg$FAILED) {
                                        s0 = peg$parsequadratic_bezier_curveto();
                                        if (s0 === peg$FAILED) {
                                            s0 = peg$parsesmooth_quadratic_bezier_curveto();
                                            if (s0 === peg$FAILED) {
                                                s0 = peg$parseelliptical_arc();
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsemoveto() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 5,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                if (peg$c1.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c2); }
                }
                if (s1 !== peg$FAILED) {
                    s2 = [];
                    s3 = peg$parsewsp();
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parsewsp();
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsemoveto_argument_sequence();
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c3(s1, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsemoveto_argument_sequence() {
                var s0, s1, s2, s3, s4;

                var key    = peg$currPos * 40 + 6,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsecoordinate_pair();
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = peg$parsecomma_wsp();
                    if (s3 === peg$FAILED) {
                        s3 = null;
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parselineto_argument_sequence();
                        if (s4 !== peg$FAILED) {
                            s3 = [s3, s4];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c4(s1, s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parseclosepath() {
                var s0, s1;

                var key    = peg$currPos * 40 + 7,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                if (peg$c5.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c6); }
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c7();
                }
                s0 = s1;

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parselineto() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 8,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                if (peg$c8.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c9); }
                }
                if (s1 !== peg$FAILED) {
                    s2 = [];
                    s3 = peg$parsewsp();
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parsewsp();
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parselineto_argument_sequence();
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c10(s1, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parselineto_argument_sequence() {
                var s0, s1, s2, s3, s4;

                var key    = peg$currPos * 40 + 9,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsecoordinate_pair();
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = peg$parsecomma_wsp();
                    if (s3 === peg$FAILED) {
                        s3 = null;
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parselineto_argument_sequence();
                        if (s4 !== peg$FAILED) {
                            s3 = [s3, s4];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c4(s1, s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsehorizontal_lineto() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 10,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                if (peg$c11.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c12); }
                }
                if (s1 !== peg$FAILED) {
                    s2 = [];
                    s3 = peg$parsewsp();
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parsewsp();
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsecoordinate_sequence();
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c13(s1, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsecoordinate_sequence() {
                var s0, s1, s2, s3, s4;

                var key    = peg$currPos * 40 + 11,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsecoordinate();
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = peg$parsecomma_wsp();
                    if (s3 === peg$FAILED) {
                        s3 = null;
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parsecoordinate_sequence();
                        if (s4 !== peg$FAILED) {
                            s3 = [s3, s4];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c4(s1, s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsevertical_lineto() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 12,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                if (peg$c14.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c15); }
                }
                if (s1 !== peg$FAILED) {
                    s2 = [];
                    s3 = peg$parsewsp();
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parsewsp();
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsecoordinate_sequence();
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c16(s1, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsecurveto() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 13,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                if (peg$c17.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c18); }
                }
                if (s1 !== peg$FAILED) {
                    s2 = [];
                    s3 = peg$parsewsp();
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parsewsp();
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsecurveto_argument_sequence();
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c19(s1, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsecurveto_argument_sequence() {
                var s0, s1, s2, s3, s4;

                var key    = peg$currPos * 40 + 14,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsecurveto_argument();
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = peg$parsecomma_wsp();
                    if (s3 === peg$FAILED) {
                        s3 = null;
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parsecurveto_argument_sequence();
                        if (s4 !== peg$FAILED) {
                            s3 = [s3, s4];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c4(s1, s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsecurveto_argument() {
                var s0, s1, s2, s3, s4, s5;

                var key    = peg$currPos * 40 + 15,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsecoordinate_pair();
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsecomma_wsp();
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsecoordinate_pair();
                        if (s3 !== peg$FAILED) {
                            s4 = peg$parsecomma_wsp();
                            if (s4 === peg$FAILED) {
                                s4 = null;
                            }
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parsecoordinate_pair();
                                if (s5 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c20(s1, s3, s5);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsesmooth_curveto() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 16,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                if (peg$c21.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c22); }
                }
                if (s1 !== peg$FAILED) {
                    s2 = [];
                    s3 = peg$parsewsp();
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parsewsp();
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsesmooth_curveto_argument_sequence();
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c23(s1, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsesmooth_curveto_argument_sequence() {
                var s0, s1, s2, s3, s4;

                var key    = peg$currPos * 40 + 17,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsesmooth_curveto_argument();
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = peg$parsecomma_wsp();
                    if (s3 === peg$FAILED) {
                        s3 = null;
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parsesmooth_curveto_argument_sequence();
                        if (s4 !== peg$FAILED) {
                            s3 = [s3, s4];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c4(s1, s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsesmooth_curveto_argument() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 18,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsecoordinate_pair();
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsecomma_wsp();
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsecoordinate_pair();
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c24(s1, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsequadratic_bezier_curveto() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 19,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                if (peg$c25.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c26); }
                }
                if (s1 !== peg$FAILED) {
                    s2 = [];
                    s3 = peg$parsewsp();
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parsewsp();
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsequadratic_bezier_curveto_argument_sequence();
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c27(s1, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsequadratic_bezier_curveto_argument_sequence() {
                var s0, s1, s2, s3, s4;

                var key    = peg$currPos * 40 + 20,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsequadratic_bezier_curveto_argument();
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = peg$parsecomma_wsp();
                    if (s3 === peg$FAILED) {
                        s3 = null;
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parsequadratic_bezier_curveto_argument_sequence();
                        if (s4 !== peg$FAILED) {
                            s3 = [s3, s4];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c4(s1, s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsequadratic_bezier_curveto_argument() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 21,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsecoordinate_pair();
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsecomma_wsp();
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsecoordinate_pair();
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c24(s1, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsesmooth_quadratic_bezier_curveto() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 22,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                if (peg$c28.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c29); }
                }
                if (s1 !== peg$FAILED) {
                    s2 = [];
                    s3 = peg$parsewsp();
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parsewsp();
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsesmooth_quadratic_bezier_curveto_argument_sequence();
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c30(s1, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsesmooth_quadratic_bezier_curveto_argument_sequence() {
                var s0, s1, s2, s3, s4;

                var key    = peg$currPos * 40 + 23,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsecoordinate_pair();
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = peg$parsecomma_wsp();
                    if (s3 === peg$FAILED) {
                        s3 = null;
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parsesmooth_quadratic_bezier_curveto_argument_sequence();
                        if (s4 !== peg$FAILED) {
                            s3 = [s3, s4];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c4(s1, s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parseelliptical_arc() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 24,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                if (peg$c31.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c32); }
                }
                if (s1 !== peg$FAILED) {
                    s2 = [];
                    s3 = peg$parsewsp();
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parsewsp();
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parseelliptical_arc_argument_sequence();
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c33(s1, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parseelliptical_arc_argument_sequence() {
                var s0, s1, s2, s3, s4;

                var key    = peg$currPos * 40 + 25,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parseelliptical_arc_argument();
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = peg$parsecomma_wsp();
                    if (s3 === peg$FAILED) {
                        s3 = null;
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseelliptical_arc_argument_sequence();
                        if (s4 !== peg$FAILED) {
                            s3 = [s3, s4];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c4(s1, s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parseelliptical_arc_argument() {
                var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;

                var key    = peg$currPos * 40 + 26,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsenonnegative_number();
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsecomma_wsp();
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsenonnegative_number();
                        if (s3 !== peg$FAILED) {
                            s4 = peg$parsecomma_wsp();
                            if (s4 === peg$FAILED) {
                                s4 = null;
                            }
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parsenumber();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parsecomma_wsp();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parseflag();
                                        if (s7 !== peg$FAILED) {
                                            s8 = peg$parsecomma_wsp();
                                            if (s8 === peg$FAILED) {
                                                s8 = null;
                                            }
                                            if (s8 !== peg$FAILED) {
                                                s9 = peg$parseflag();
                                                if (s9 !== peg$FAILED) {
                                                    s10 = peg$parsecomma_wsp();
                                                    if (s10 === peg$FAILED) {
                                                        s10 = null;
                                                    }
                                                    if (s10 !== peg$FAILED) {
                                                        s11 = peg$parsecoordinate_pair();
                                                        if (s11 !== peg$FAILED) {
                                                            peg$savedPos = s0;
                                                            s1 = peg$c34(s1, s3, s5, s7, s9, s11);
                                                            s0 = s1;
                                                        } else {
                                                            peg$currPos = s0;
                                                            s0 = peg$FAILED;
                                                        }
                                                    } else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                } else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsecoordinate_pair() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 27,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsecoordinate();
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsecomma_wsp();
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsecoordinate();
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c35(s1, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsecoordinate() {
                var s0, s1;

                var key    = peg$currPos * 40 + 28,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsenumber();
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c36(s1);
                }
                s0 = s1;

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsenonnegative_number() {
                var s0;

                var key    = peg$currPos * 40 + 29,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$parsefloating_point_constant();
                if (s0 === peg$FAILED) {
                    s0 = peg$parsedigit_sequence();
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsenumber() {
                var s0, s1, s2;

                var key    = peg$currPos * 40 + 30,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsesign();
                if (s1 === peg$FAILED) {
                    s1 = null;
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsefloating_point_constant();
                    if (s2 !== peg$FAILED) {
                        s1 = [s1, s2];
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$parsesign();
                    if (s1 === peg$FAILED) {
                        s1 = null;
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parsedigit_sequence();
                        if (s2 !== peg$FAILED) {
                            s1 = [s1, s2];
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parseflag() {
                var s0;

                var key    = peg$currPos * 40 + 31,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                if (input.charCodeAt(peg$currPos) === 48) {
                    s0 = peg$c37;
                    peg$currPos++;
                } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c38); }
                }
                if (s0 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 49) {
                        s0 = peg$c39;
                        peg$currPos++;
                    } else {
                        s0 = peg$FAILED;
                        if (peg$silentFails === 0) { peg$fail(peg$c40); }
                    }
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsecomma_wsp() {
                var s0, s1, s2, s3, s4;

                var key    = peg$currPos * 40 + 32,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parsewsp();
                if (s2 !== peg$FAILED) {
                    while (s2 !== peg$FAILED) {
                        s1.push(s2);
                        s2 = peg$parsewsp();
                    }
                } else {
                    s1 = peg$FAILED;
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsecomma();
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = [];
                        s4 = peg$parsewsp();
                        while (s4 !== peg$FAILED) {
                            s3.push(s4);
                            s4 = peg$parsewsp();
                        }
                        if (s3 !== peg$FAILED) {
                            s1 = [s1, s2, s3];
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$parsecomma();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$parsewsp();
                        while (s3 !== peg$FAILED) {
                            s2.push(s3);
                            s3 = peg$parsewsp();
                        }
                        if (s2 !== peg$FAILED) {
                            s1 = [s1, s2];
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsecomma() {
                var s0;

                var key    = peg$currPos * 40 + 33,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                if (input.charCodeAt(peg$currPos) === 44) {
                    s0 = peg$c41;
                    peg$currPos++;
                } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c42); }
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsefloating_point_constant() {
                var s0, s1, s2;

                var key    = peg$currPos * 40 + 34,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsefractional_constant();
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseexponent();
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        s1 = [s1, s2];
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$parsedigit_sequence();
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parseexponent();
                        if (s2 !== peg$FAILED) {
                            s1 = [s1, s2];
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsefractional_constant() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 35,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = peg$parsedigit_sequence();
                if (s1 === peg$FAILED) {
                    s1 = null;
                }
                if (s1 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 46) {
                        s2 = peg$c43;
                        peg$currPos++;
                    } else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) { peg$fail(peg$c44); }
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsedigit_sequence();
                        if (s3 !== peg$FAILED) {
                            s1 = [s1, s2, s3];
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$parsedigit_sequence();
                    if (s1 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s2 = peg$c43;
                            peg$currPos++;
                        } else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) { peg$fail(peg$c44); }
                        }
                        if (s2 !== peg$FAILED) {
                            s1 = [s1, s2];
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parseexponent() {
                var s0, s1, s2, s3;

                var key    = peg$currPos * 40 + 36,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                if (peg$c45.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c46); }
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsesign();
                    if (s2 === peg$FAILED) {
                        s2 = null;
                    }
                    if (s2 !== peg$FAILED) {
                        s3 = peg$parsedigit_sequence();
                        if (s3 !== peg$FAILED) {
                            s1 = [s1, s2, s3];
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsesign() {
                var s0;

                var key    = peg$currPos * 40 + 37,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                if (input.charCodeAt(peg$currPos) === 43) {
                    s0 = peg$c47;
                    peg$currPos++;
                } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c48); }
                }
                if (s0 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 45) {
                        s0 = peg$c49;
                        peg$currPos++;
                    } else {
                        s0 = peg$FAILED;
                        if (peg$silentFails === 0) { peg$fail(peg$c50); }
                    }
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsedigit_sequence() {
                var s0, s1, s2;

                var key    = peg$currPos * 40 + 38,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                s0 = peg$currPos;
                s1 = [];
                if (peg$c51.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c52); }
                }
                if (s2 !== peg$FAILED) {
                    while (s2 !== peg$FAILED) {
                        s1.push(s2);
                        if (peg$c51.test(input.charAt(peg$currPos))) {
                            s2 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) { peg$fail(peg$c52); }
                        }
                    }
                } else {
                    s1 = peg$FAILED;
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c53(s1);
                }
                s0 = s1;

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }

            function peg$parsewsp() {
                var s0;

                var key    = peg$currPos * 40 + 39,
                    cached = peg$resultsCache[key];

                if (cached) {
                    peg$currPos = cached.nextPos;

                    return cached.result;
                }

                if (peg$c54.test(input.charAt(peg$currPos))) {
                    s0 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c55); }
                }

                peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

                return s0;
            }


            // The last coordinate we are at in the path. In absolute coords.
            var lastCoord = [0, 0];
            // The last control point we encountered in the path. In absolute coords.
            var lastControl = [0, 0];
            // The list of operations we've parsed so far.
            var ops = [];
            // Have we parsed the first sub-path yet?
            var firstSubPath = true;
            // The letter of the last parsed command.
            var lastCh = '';

            // Flatten an array.
            function flatten(a) {
                var flat = [];
                for (var i = 0; i < a.length; i++) {
                    if (a[i] instanceof Array) {
                        flat.push.apply(flat, flatten(a[i]));
                    } else {
                        flat.push(a[i]);
                    }
                }
                return flat;
            }

            // Convert a position into an absolute position.
            function makeAbsolute(c, coord) {
                if ('mlazhvcsqt'.indexOf(c) === -1) {
                    lastCoord = coord;
                } else {
                    lastCoord[0] += coord[0];
                    lastCoord[1] += coord[1];
                }
                lastCh = c;
                return lastCoord.slice(0);
            }

            // Convert a sequence of coordinates into absolute coordinates.
            //
            // For arguments that take multiple coord pairs, such as bezier.
            function makeAbsoluteMultiple(c, seq) {
                var r = [];
                var lastPosCopy = lastCoord.slice(0);
                for (var i=0; i < seq.length; i+=2) {
                    // Only the last point should update lastCoord.
                    lastCoord = lastPosCopy.slice(0);
                    var coord = makeAbsolute(c, seq.slice(i, i+2));
                    r = r.concat(coord);
                    // Record the last control point, it might be needed for
                    // shorthand operations.
                    if (i == seq.length-4) {
                        lastControl = coord.slice(0);
                    }
                }
                return r;
            }

            // Find the reflection of the last control point over
            // the last postion in the path.
            function makeReflected() {
                if ('CcSsQqTt'.indexOf(lastCh) == -1) {
                    lastControl = lastCoord.slice(0);
                }
                // reflected = 2*lastCoord - lastControl
                // Note the result is absolute, not relative.
                var r = [0, 0];
                r[0] = 2*lastCoord[0] - lastControl[0];
                r[1] = 2*lastCoord[1] - lastControl[1];
                return r;
            }

            function makeAbsoluteFromX(c, x) {
                var coord = [x, 0];
                if (c == 'H') {
                    coord[1] = lastCoord[1];
                }
                return makeAbsolute(c, coord);
            }

            function makeAbsoluteFromY(c, y) {
                var coord = [0, y];
                if (c == 'V') {
                    coord[0] = lastCoord[0];
                }
                return makeAbsolute(c, coord);
            }

            function concatSequence(one, rest) {
                var r = [one];
                if (rest && rest.length > 1) {
                    var rem = rest[1];
                    for (var i = 0; i < rem.length; i++) {
                        r.push(rem[i]);
                    }
                }
                return r;
            }

            function mag(v) {
                return Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2));
            }

            function dot(u, v) {
                return (u[0]*v[0] + u[1]*v[1]);
            }

            function ratio(u, v) {
                return dot(u,v) / (mag(u)*mag(v))
            }

            function angle(u, v) {
                var sign = 1.0;
                if ((u[0]*v[1] - u[1]*v[0]) < 0) {
                    sign = -1.0;
                }
                return sign * Math.acos(ratio(u,v));
            }

            function rotClockwise(v, angle) {
                var cost = Math.cos(angle);
                var sint = Math.sin(angle);
                return [cost*v[0] + sint*v[1], -1 * sint*v[0] + cost*v[1]];
            }

            function rotCounterClockwise(v, angle) {
                var cost = Math.cos(angle);
                var sint = Math.sin(angle);
                return [cost*v[0] - sint*v[1], sint*v[0] + cost*v[1]];
            }

            function midPoint(u, v) {
                return [(u[0] - v[0])/2.0, (u[1] - v[1])/2.0];
            }

            function meanVec(u, v) {
                return [(u[0] + v[0])/2.0, (u[1] + v[1])/2.0];
            }

            function pointMul(u, v) {
                return [u[0]*v[0], u[1]*v[1]];
            }

            function scale(c, v) {
                return [c*v[0], c*v[1]];
            }

            function sum(u, v) {
                return [u[0] + v[0], u[1] + v[1]];
            }

            // Convert an SVG elliptical arc to a series of canvas commands.
            //
            // x1, x2: start and stop coordinates of the ellipse.
            // rx, ry: radii of the ellipse.
            // phi: rotation of the ellipse.
            // fA: large arc flag.
            // fS: sweep flag.
            function ellipseFromEllipticalArc(x1, rx, ry, phi, fA, fS, x2) {
                // Convert from endpoint to center parametrization, as detailed in:
                //   http://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
                if (rx == 0 || ry == 0) {
                    ops.push({type: 'lineTo', args: x2});
                    return;
                }
                var phi = phi * (Math.PI / 180.0);
                rx = Math.abs(rx);
                ry = Math.abs(ry);
                var xPrime = rotClockwise(midPoint(x1, x2), phi);                // F.6.5.1
                var xPrime2 = pointMul(xPrime, xPrime);
                var rx2 = Math.pow(rx, 2);
                var ry2 = Math.pow(ry, 2);

                var lambda = Math.sqrt(xPrime2[0]/rx2 + xPrime2[1]/ry2);
                if (lambda > 1) {
                    rx *= lambda;
                    ry *= lambda;
                    rx2 = Math.pow(rx, 2);
                    ry2 = Math.pow(ry, 2);
                }

                var factor = Math.sqrt((rx2*ry2 - rx2*xPrime2[1] - ry2*xPrime2[0]) /
                    (rx2*xPrime2[1] + ry2*xPrime2[0]));
                if (fA == fS) {
                    factor *= -1.0;
                }
                var cPrime = scale(factor, [rx*xPrime[1]/ry, -ry*xPrime[0]/rx]); // F.6.5.2
                var c = sum(rotCounterClockwise(cPrime, phi), meanVec(x1, x2));  // F.6.5.3
                var x1UnitVector = [(xPrime[0] - cPrime[0])/rx, (xPrime[1] - cPrime[1])/ry];
                var x2UnitVector = [(-1.0*xPrime[0] - cPrime[0])/rx, (-1.0*xPrime[1] - cPrime[1])/ry];
                var theta = angle([1, 0], x1UnitVector);                         // F.6.5.5
                var deltaTheta = angle(x1UnitVector, x2UnitVector);              // F.6.5.6
                var start = theta;
                var end = theta+deltaTheta;
                ops.push(
                    {type: 'save', args: []},
                    {type: 'translate', args: [c[0], c[1]]},
                    {type: 'rotate', args: [phi]},
                    {type: 'scale', args: [rx, ry]},
                    {type: 'arc', args: [0, 0, 1, start, end, 1-fS]},
                    {type: 'restore', args: []}
                );
            }


            peg$result = peg$startRuleFunction();

            if (peg$result !== peg$FAILED && peg$currPos === input.length) {
                return peg$result;
            } else {
                if (peg$result !== peg$FAILED && peg$currPos < input.length) {
                    peg$fail(peg$endExpectation());
                }

                throw peg$buildStructuredError(
                    peg$maxFailExpected,
                    peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
                    peg$maxFailPos < input.length
                        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
                        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
                );
            }
        }

        return {
            SyntaxError: peg$SyntaxError,
            parse:       peg$parse
        };
    })();
